// material-ui
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import logo from 'assets/images/yayfi-logo-primary.svg';

export default function LogoMain() {
 const theme = useTheme();
   
return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.2,
        color: theme.palette.common.black
      }}
    >
      {/* LOGO */}
      <img src={logo} alt="YaYfi" width={148} height={46} />

      
    </Box>
  );
}
